export default __webpack_public_path__ + "static/media/Ballroll_00134.ab54d868.png";